import { CallRequest, ContactRequest, EmailMessage, EmailType } from '@/types/EmailType'
import { escapeHtml } from './utils'

export async function sendEmail(
  emailType: EmailType,
  model: ContactRequest | CallRequest
): Promise<void> {
  const message = buildEmailMessage(emailType, model)

  try {
    const response = await fetch('/api/acq-components/email/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(message)
    })

    if (!response.ok) {
      throw new Error(`Failed to send ${emailType}: ${response.status}`)
    }
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    throw error instanceof Error ? error : new Error(errorMessage)
  }
}

const buildEmailMessage = (
  emailType: EmailType,
  model: ContactRequest | CallRequest
): Omit<EmailMessage, 'sender' | 'recipient'> => {
  if (emailType === 'ContactRequest') {
    const contactModel = model as ContactRequest

    return {
      emailType,
      model: {
        email: contactModel.email,
        name: contactModel.name,
        telephoneNumber: contactModel.telephoneNumber,
        enquiry: contactModel.enquiry,
        source: contactModel.source || '',
        medium: contactModel.medium || '',
        campaign: contactModel.campaign || ''
      }
    }
  }

  const callModel = model as CallRequest

  return {
    emailType,
    model: {
      alreadyApplied: callModel.alreadyApplied,
      name: escapeHtml(callModel.name),
      telephoneNumber: escapeHtml(callModel.telephoneNumber),
      source: escapeHtml(callModel.source || ''),
      medium: escapeHtml(callModel.medium || ''),
      campaign: escapeHtml(callModel.campaign || '')
    }
  }
}
